export enum NoteType {
    INFO,
    WARNING,
    ERROR,
}
